export default "__VITE_ASSET__BLCH4PoO__"